import api from './apiClient';

const apiValidateToken = async () => {
    try {
        const token = localStorage.getItem('captions_token');
        if (!token) {
            return { valid: false };
        }

        const response = await api.post('/api/captions/validate-token', null, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (response.data.valid) {
            return {
                valid: true,
                user_id: response.data.user_id,
                email: response.data.email,
                first_name: response.data.first_name,
            };
        }

        return { valid: false };
    } catch (error) {
        return { valid: false, error: error.response?.data?.error || 'Validation failed' };
    }
};

export default apiValidateToken;
